import * as React from "react";

// Navigate
// import { useNavigate } from "react-router-dom";

// CSS
import "@/styles/components/staffCardStyles.css";

// Components
import { CurrencyFormat } from "@/config/normalConfig";

// Mui Styles
import { StyledCard } from "@/styles/mui/globalStyles";
import IconButton from "@mui/material/IconButton";

// Mui
import Typography from "@mui/material/Typography";

// Mui Icon
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import DriveFolderUploadIcon from "@mui/icons-material/DriveFolderUpload";
import DownloadIcon from "@mui/icons-material/Download";

export default function StaffCard(props) {
  // Navigate
  // const navigate = useNavigate();

  let temp, temp2;

  if (props.type === "daily") {
    temp = props.full_name;
    temp2 = props.role_types_name;
  }
  if (props.type === "refill") {
    temp = props.displayName;
  }
  return (
    <StyledCard onClick={props.onClick}>
      <div className="staffCardContainer">
        <span className="shape" />
        <div className="staffIconContainer">
          <AccountCircleOutlinedIcon sx={{ fontSize: 54, zIndex: 11 }} />
        </div>
        <span className="filter" />
        <span className="topBox" />
      </div>
      <Typography
        variant="h6"
        noWrap
        component="h6"
        sx={{
          margin: "48px 0px 0px",
          fontWeight: "600",
          lineHeight: "1.5",
          fontSize: "1rem",
        }}
      >
        {temp}
      </Typography>
      <Typography variant="p" noWrap component="p">
        {temp2}
      </Typography>

      <hr className="divider" />
      <div className="grid">
        {props.type === "refill" && (
          <div>
            {props.download && (
              <IconButton
                component="label"
                onClick={props.onClickDownload}
                disabled={props.disable}
              >
                <DownloadIcon disable={props.disable} />
              </IconButton>
            )}
            {props.upload && (
              <IconButton component="label">
                <DriveFolderUploadIcon />
                <input
                  hidden
                  type={"file"}
                  id={"csvFileInput"}
                  accept={".csv"}
                  onChange={props.onChangeUpload}
                />
              </IconButton>
            )}
          </div>
        )}
        {/* {props.type === "refill" && (
          <div>
            <Typography variant="caption" noWrap component="div">
              {props.isApprove ? "批准貨品總數" : "申請貨品總數"}
            </Typography>
            <Typography
              variant="subtitle1"
              noWrap
              component="div"
              sx={{ fontWeight: "bold" }}
            >
              {total} 件
            </Typography>
          </div>
        )} */}
        {props.type === "daily" && (
          <div>
            <Typography variant="caption" noWrap component="div">
              已完成金額
            </Typography>
            <Typography
              variant="subtitle1"
              noWrap
              component="div"
              sx={{ fontWeight: "bold" }}
            >
              {CurrencyFormat(props.invoice_total ? props.invoice_total : 0)}
            </Typography>
          </div>
        )}
      </div>
    </StyledCard>
  );
}
